import { Component, OnInit } from '@angular/core';
import { Http } from "@angular/http";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {

    constructor(http: Http, private route: ActivatedRoute) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/auth/auth.component.ts